import type { NewsItem } from '@/types/film';

export const newsList: NewsItem[] = [
  {
    id: 'news-01',
    title: '《星海回声》发布首支预告：一场跨越三十年的深空回信',
    category: '预告片',
    date: '2026-10-12',
    excerpt:
      '导演沈岸在预告发布会上表示，影片所有的太空场景都坚持实景模型与光影结合，希望观众能听见"沉默的声音"。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20press%20still%20of%20a%20space%20mission%20control%20room%2C%20blue%20screens%20and%20warm%20desk%20lamps%2C%20people%20watching%20a%20projection%2C%20film%20production%20atmosphere&width=800&height=520&seq=qqc-n01&orientation=landscape',
  },
  {
    id: 'news-02',
    title: '悬疑剧《长夜未央》收官，雨夜那场戏拍了整整十一天',
    category: '剧集动态',
    date: '2026-10-08',
    excerpt:
      '主创团队透露，全剧最关键的一场雨戏使用了真实降雨系统，主演在低温中连续拍摄，最终留下了全片最长的一个镜头。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20photo%20of%20a%20rainy%20night%20street%20set%20with%20film%20cameras%20and%20warm%20lights%2C%20blue%20evening%20tones&width=800&height=520&seq=qqc-n02&orientation=landscape',
  },
  {
    id: 'news-03',
    title: '十月片单：五部值得留到深夜看的华语新片',
    category: '月度片单',
    date: '2026-10-03',
    excerpt:
      '从硬科幻到小院烟火气，这一份片单涵盖了本月最具讨论度的五部作品，也附上了适合观看的时间与心情建议。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20flat%20lay%20of%20film%20posters%20and%20a%20notebook%20on%20a%20wooden%20table%2C%20warm%20lamp%20light%2C%20deep%20navy%20and%20amber%20tones&width=800&height=520&seq=qqc-n03&orientation=landscape',
  },
  {
    id: 'news-04',
    title: '从《雾都十二时》看英式推理的节奏感：慢，但从不拖',
    category: '深度解读',
    date: '2026-09-27',
    excerpt:
      '八集的体量里，编剧把线索藏在每一次沉默里。我们梳理了剧中三个最容易被忽略的细节，它们决定了最终的答案。',
    image:
      'https://readdy.ai/api/search-image?query=Foggy%20old%20European%20street%20with%20a%20clock%20tower%20at%20dusk%2C%20warm%20window%20lights%2C%20deep%20blue%20mist%2C%20cinematic%20mood&width=800&height=520&seq=qqc-n04&orientation=landscape',
  },
];